// Unknown address (an old link, a typo): say so and lead back home instead of an empty screen.
// The page view (with its path) is recorded by the usual screen tracking.
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import '@/features/help/help.css';

export function NotFound() {
  const { t } = useTranslation('common');
  return (
    <main className="page help-page">
      <h1 className="lg-title">{t('notFound.title')}</h1>
      <p className="hint">{t('notFound.lead')}</p>
      <Link className="btn btn-primary btn-block" to="/">{t('notFound.home')}</Link>
      <Link className="btn btn-text btn-block" to="/help">{t('notFound.help')}</Link>
    </main>
  );
}
